import { ApiInstance } from '../..';

export type CarCalendarDTO = {
    carId?: number;
    vin: string;
    vehicleName: string;
    bookings: BookingSlotDTO[];
    workOrders: WorkOrderSlotDTO[];
};

export type BookingSlotDTO = {
    turoReservationId: number;
    reservationId: string;
    guest: string;
    tripStart: string;
    tripEnd: string;
    tripStatus: string;
};

export type WorkOrderSlotDTO = {
    carInServiceId: number;
    status?: string;
    priority?: string;
    startDate?: string;
    endDate?: string;
    serviceNames?: string[];
};

export const getReservationCalendar = async (
    startDate: string,
    endDate: string
): Promise<{ data: CarCalendarDTO[] }> => {
    const result = await ApiInstance.getInstance().get(
        '/api/reservation-calendar',
        {
            params: { startDate, endDate },
        }
    );
    return result;
};
